@if (this.api; as api) {
  @let columns = this.columns();
  @let rows = this.rows();
  @let version = this.version();

  <div class="grid-table-container">
    <table class="grid-table">
      <thead>
        <tr>
          @for (column of columns; track this.trackColumn(column)) {
            <th [style.width.px]="column.getActualWidth()">
              <cam-grid-table-header-cell
                [api]="api"
                [column]="column"
                [version]="version"
              ></cam-grid-table-header-cell>
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (node of rows; track this.trackRow(node)) {
          @if (node.data) {
            <tr
              class="grid-table-row"
              [class.is-selected]="this.isSelected(node)"
              [class.is-expandable]="node.isExpandable()"
              [style.--tree-level]="node.level"
              (click)="this.clickRow(node, $event)"
            >
              @for (column of columns; track this.trackColumn(column); let first = $first) {
                <td [class]="this.cellClass(column, node)" [class.is-first]="first">
                  @if (first && node.isExpandable()) {
                    <span class="tree-toggle" (click)="this.toggleExpanded(node, $event)">
                      <cam-font-icon
                        [name]="node.expanded ? 'arrow-big-bottom' : 'arrow-big-right'"
                        type="xs"
                      ></cam-font-icon>
                    </span>
                  }
                  <cam-grid-table-cell
                    [api]="api"
                    [column]="column"
                    [node]="node"
                    [version]="version"
                    [style]="this.cellStyle(column, node)"
                  ></cam-grid-table-cell>
                </td>
              }
            </tr>
          } @else {
            <tr class="grid-table-row is-loading">
              <td [attr.colspan]="columns.length">
                <div class="loading-cell">
                  <cam-ag-grid-loading></cam-ag-grid-loading>
                </div>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>

    @if (rows.length === 0) {
      <cam-empty text="grid.common.no-rows"></cam-empty>
    }
  </div>
}
